// src/components/CustomPagination.js
import React from 'react';
import { PiArrowLeftBold, PiArrowRightBold } from 'react-icons/pi';
import { useSearchParams } from 'react-router-dom';
import { cn } from 'src/utils/functions'; // optional className utility

function CustomPagination({ currentPage, totalPages }) {
    const [searchParams, setSearchParams] = useSearchParams();

    const handlePageChange = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams);
    };

    return (
        <div className={cn("flex items-center justify-between px-4 py-3 gap-3")}>
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage <= 1}
                className="p-2 rounded-md text-primary border border-primary hover:bg-primary hover:text-white disabled:opacity-50"
            >
                <PiArrowLeftBold size="20" />
            </button>

            <span className="text-[1.6rem] text-gray font-normal text-center flex-grow">
                Page {currentPage} of {totalPages}
            </span>

            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= totalPages}
                className="p-2 rounded-md text-primary border border-primary hover:bg-primary hover:text-white disabled:opacity-50"
            >
                <PiArrowRightBold size="20" />
            </button>
        </div>
    );
}

export default CustomPagination;
